/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const ColdSweatIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path d='M25.8 1C18.7 1 12.4 4.1 8 9c.3.5.7.9 1 1.4 4.1-4.7 10.1-7.7 16.8-7.7 12.3 0 22.3 10 22.3 22.3s-10 22.3-22.3 22.3S3.5 37.3 3.5 25c0-.6 0-1.2.1-1.8-.6-.2-1.1-.6-1.6-1-.1.9-.2 1.8-.2 2.8 0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24z' />
			<path d='M10.6 25.9c-.5 0-.9.3-1.3.8-.9 1.2-1.7 2.5-2.4 3.8-.4.7-.5 1.5-.5 2.3.1 1 .6 2 1.4 2.6.7.6 1.5.9 2.4.9h.4c.7 0 1.3-.1 1.9-.4 1.9-.9 2.7-3.2 1.8-5.1-.7-1.4-1.6-2.8-2.6-4-.4-.8-.8-.9-1.1-.9zm.3 1.3c.9 1.2 1.8 2.5 2.5 3.9s.1 3.1-1.3 3.8c-.5.2-1 .3-1.5.3-.8 0-1.6-.2-2.1-.7s-1-1.2-1-1.9c-.1-.6.1-1.2.3-1.7.7-1.3 1.5-2.5 2.4-3.7.2-.3.4-.4.5-.4 0 .1.1.2.2.4zM30.8 33.1c-.3-.3-.7-.3-1 0l-1.5 1.1-1.3-1.1-.1-.1c-.3-.3-.8-.2-1 .1l-1.2 1.1c-.5-.4-1-.8-1.4-1.1-.3-.3-.7-.3-1 0-.3.2-.5.4-.8.6-.3.3-.7.6-1 .9-.3.2-.3.7-.1 1 .2.3.6.4.9.1.1-.1.2-.1.3-.2l1.2-1 1.4 1.1.1.1c.3.3.7.2 1-.1l1.2-1.1s.1 0 .1.1c.3.3.7.6 1 .9.5.4.7.5 1.3 0l1.3-1 1.2 1.1c.2.2.5.3.7.2.1 0 .2-.1.3-.2.2-.3.2-.7-.1-1-.3-.5-.9-1-1.5-1.5.1 0 .1 0 0 0zM18.9 18.4c-1.3 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.3 0 2.3-1 2.3-2.3 0-1.3-1.1-2.3-2.3-2.3zM36.1 20.7c0-1.3-1.1-2.3-2.3-2.3-1.3 0-2.3 1.1-2.3 2.3 0 1.3 1.1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3zM6.5 22.1c1.9 0 3.5-.8 4.3-2.2.8-1.3.9-2.9.2-4.4-.9-1.8-2-3.4-3.2-5-.5-.7-1-.8-1.4-.8-.5-.1-1 .3-1.4.8-1.1 1.5-2.1 3-3 4.7-.8 1.6-.8 3.3.1 4.6.9 1.4 2.5 2.3 4.4 2.3zm-3.6-6.4c.9-1.6 1.8-3.1 2.9-4.5.2-.3.5-.5.6-.5.2 0 .4.3.6.4 1.2 1.5 2.2 3.2 3.1 4.8.6 1.2.5 2.4-.1 3.4-.7 1.1-2 1.7-3.4 1.8-1.6 0-2.9-.7-3.6-1.8s-.7-2.4-.1-3.6z' />
		</svg>
	)
}

export default ColdSweatIcon
